import { configure } from "vee-validate/dist/vee-validate.cjs";

configure({
  validateOnBlur: false,
  validateOnChange: false,
  validateOnInput: false,
  validateOnModelUpdate: false,
});

export * from "vee-validate/dist/vee-validate.cjs";
